import { useAuth } from "../../../context/AuthContext";

// Per-client module switches (superadmin → CompanyModulePermission).
// The row is now fetched and cached once in AuthContext for every shell;
// this hook keeps the old `{ modulePermissions, loadingPermissions }` shape
// so the shell reads the same data the permission helpers enforce. The
// arguments are accepted for call-site compatibility and ignored.
export function useModulePermissions(/* BASE_URL, profile */) {
  const { clientModules, clientModulesLoading } = useAuth();
  return { modulePermissions: clientModules, loadingPermissions: clientModulesLoading };
}
